import styled from 'styled-components';

export const DefaultContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;

  .imgWidth {
    width: 56px;
    height: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: 992px) {
      width: 65px;
      height: 65px;
    }
  }
`;
